import React, { useCallback, useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import Airtel from "../assets/Airtel.png";
import Glo from "../assets/Glo.jpeg";
import MTN from "../assets/MTN.jpeg";
import Nmobile from "../assets/9mobile.jpeg";
import { Tab } from "@headlessui/react";
import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  billerGroup,
  billerGroupEnquiry,
  delgroAirtimePurchase,
  handleDeleteBeneficiary,
  handleUserBeneficiaryFetch,
} from "../store/actions/vasActions";
import toast from "react-hot-toast";
import { authService } from "../services/authService";
import { Menu } from '@headlessui/react';
import PayBillImage from "../assets/payBillImage.png";
import {
  getTransactions,
  getWalletBalance,
} from "../store/actions";
import IsLoadingFour from "./IsloadingFour";
import { BiSearch } from "react-icons/bi";
import { LuArrowLeft, LuCheckCircle2 } from "react-icons/lu";
import { BsThreeDotsVertical } from "react-icons/bs";

function BuyAirtimePopover({ onClose }) {
  const dispatch = useDispatch();
  const [selectedBeneficiary, setSelectedBeneficiary] = useState({});
  const [phone, setPhone] = useState("");
  const [amount, setAmount] = useState("");
  const [fetchedBillerGroups, setFetchedBillergroups] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [packageSlug, setPackageSlug] = useState("AIRTEL_VTU");
  const [isSavingBeneficiary, setIsSavingBeneficiary] = useState(true);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [filteredBeneficiaries, setFilteredBeneficiaries] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const { walletBalance } = useSelector((state) => state.user);
  const { billerGrpEnq, biller } = useSelector((state) => state.vas);
  const [otp, setOtp] = useState(new Array(4).fill(""));

  const networks = ["AIRTEL_VTU", "GLO_VTU", "MTN_VTU", "9MOBILE_VTU"];
  const [tabIndex, setTabIndex] = useState(
    networks.indexOf(packageSlug) >= 0 ? networks.indexOf(packageSlug) : 0
  );

  const verification_code = authService.getCurrentUserVerificationCode();
  const userId = authService.getCurrentUserID();
  const customerId = authService.getCurrentCustomerId();

  const [searchNumber, setSearchNumber] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    if (!biller) {
      dispatch(billerGroup());
    }
  }, [biller, dispatch]);

  const handleBeneFetch = useCallback(() => {
    try {
      dispatch(handleUserBeneficiaryFetch(customerId)).unwrap().then((res) => {
        setBeneficiaries(res);
      }).catch((err) => {
        return err;
      })
    } catch (err) {
      return err;
    }
  }, [customerId, dispatch]);

  const handleBeneFetchBase = (beneficiaries) => {
    return beneficiaries?.map((beneficiary) => {

        let companyLogo = null;

        switch (beneficiary?.company_name) {
          case 'AIRTEL_VTU':
            companyLogo = Airtel;
            break;
          case 'GLO_VTU':
            companyLogo = Glo;
            break;
          case 'MTN_VTU':
            companyLogo = MTN;
            break;
          case '9MOBILE_VTU':
            companyLogo = Nmobile;
            break;
          default:
            companyLogo = null;
        }

        const filtered = {
          id: beneficiary?.id,
          number: beneficiary?.mobile_number,
          network: beneficiary?.company_name,
          logo: companyLogo
        }
        return filtered;
      });
  }

  // useEffect(() => {
  //   if (beneficiaries?.length) {
  //     const filteredBene = 

  //     setFilteredBeneficiaries(filteredBene);
  //   }
  // }, [beneficiaries]);

  useEffect(() => {
        if (beneficiaries?.length) {
          let filteredBene = [];
          if (searchTerm?.length) {
            const searched = beneficiaries?.filter((bene) => bene?.mobile_number?.includes(searchTerm));
  
            filteredBene = handleBeneFetchBase(searched);
  
            setFilteredBeneficiaries(filteredBene);
          } else {
            filteredBene = handleBeneFetchBase(beneficiaries);
            setFilteredBeneficiaries(filteredBene);
          }
  
        }
        
      }, [beneficiaries, searchTerm]);

  useEffect(() => {
    handleBeneFetch();
  }, [handleBeneFetch]);

  useEffect(() => {
    if (biller) {
      const filteredBiller =
        biller &&
        biller?.length &&
        biller?.filter((bill) => bill.slug === "AIRTIME_AND_DATA");
      setFetchedBillergroups(filteredBiller);
    }
  }, [biller]);

  useEffect(() => {
    if (selectedId) {
      const filteredBene = filteredBeneficiaries.find((bene) => bene.id === selectedId);
      setSelectedBeneficiary(filteredBene || {});
    }
  }, [selectedId, filteredBeneficiaries]);

  useEffect(() => {
    if (selectedBeneficiary) {
      setPhone(selectedBeneficiary?.number || "");
      setPackageSlug(selectedBeneficiary.network || "AIRTEL_VTU");
      const idx = networks.indexOf(selectedBeneficiary.network);
      if (idx >= 0) setTabIndex(idx);
    }
  }, [selectedBeneficiary]);

  useEffect(() => {
    if (fetchedBillerGroups && fetchedBillerGroups?.length) {
      dispatch(billerGroupEnquiry(fetchedBillerGroups[0]?.id));
    }
  }, [fetchedBillerGroups, dispatch]);

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;

    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  const handleBeneficiarySave = () => {
    setIsSavingBeneficiary(prev => !prev);
  };

  const handleChangeAmount = (e) => {
    setAmount(e.target.value.replace(/[^0-9]/g, ""));
  };

  const handleWalletUpdate = () => {
    const data = {
      sql_ref_no: "31",
      user_id: userId.toString(),
      customer_id: customerId.toString(),
      verification_code,
      option: "1",
    };

    dispatch(getWalletBalance(data))
      .unwrap()
      .then(() => {
        setIsLoading(false);
        const id = customerId?.toString();
        dispatch(getTransactions(id));
      })
      .catch((err) => {
        return err;
      });
  };

  const handleDelete = (item) => {
      const toastId = toast.loading("Deleting beneficiary...");
      try {
        const payload = {
          customerId,
          number: item?.number
        };
  
        dispatch(handleDeleteBeneficiary(payload)).unwrap().then((res) => {
          if (res?.message_id === 1) {
            toast.success(res?.message_text, {id: toastId});
            setSearchNumber(!searchNumber);
            setSelectedId(null);
            return handleBeneFetch();
          }
          return toast.error("Beneficiary could not be deleted.", {id: toastId});
        }).catch((err) => err);
      } catch (err) {
        return err;
      }
    }

  const handlePackageInfo = (event) => {
    setPackageSlug(event.target.value);
    const idx = networks.indexOf(event.target.value);
    if (idx >= 0) setTabIndex(idx);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const toastId = toast.loading("Vending Airtime....");

    const amountToBuy = amount;

    if (!billerGrpEnq?.length) {
      return toast.error(
        "This service is temporarily unavailable, please try again later",
        {
          id: toastId,
        }
      );
    }

    if (
      !walletBalance?.available_balance ||
      walletBalance?.available_balance < amountToBuy
    ) {
      return toast.error("You have insufficient funds..", {
        id: toastId,
      });
    }

    setIsLoading(true);

    const serverData = {
      user_id: userId?.toString(),
      customer_id: customerId?.toString(),
      transaction_type_id: "2",
      mobile_number: phone,
      amount: amountToBuy,
      remark: "Buy Airtime",
      verification_code,
      transaction_pin: otp?.join(""),
      packageSlug,
      save_beneficiary_id: isSavingBeneficiary ? 1 : 0
    };

    dispatch(delgroAirtimePurchase(serverData))
      .unwrap()
      .then((res) => {
        if (res && res?.status === 403) {
          setIsLoading(false);
          return toast.error(res.response.error, {
            id: toastId,
          });
        }

        onClose();
        setIsLoading(false);
        toast.success(res[0]?.Message_Text, {
          id: toastId,
        });
        return handleWalletUpdate();
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error("Vend Airtime failed", {
          id: toastId,
        });
      });
  };

  return (
    <div className="relative h-fit bg-white rounded-2xl overflow-hidden">
      <div className="bg-white px-3 py-3 text-gray-500 xsm:px-6 xsm:py-4 overflow-auto h-fit max-h-[95vh]">
        <div className="w-full flex items-center justify-between">
          <div className="text-lg font-bold text-gray-600">Buy Airtime</div>
          <button
            onClick={() => onClose()}
            className="rounded-full p-1 hover:bg-gray-100 active:bg-gray-200"
            aria-label="Close"
          >
            <IoClose className="h-5 w-5 text-gravel-500" />
          </button>
        </div>

        {searchNumber ? (
          <div className="w-full min-w-[270px] sm:min-w-[340px] flex-1">
            <div className="mt-4 w-full">
              <div className="flex items-center space-x-2 text-sm font-semibold text-gravel-500">
                <span onClick={()=>setSearchNumber(!searchNumber)} className="size-6 flex items-center justify-center rounded-full cursor-pointer hover:bg-gray-200 active:bg-gray-100">
                  <LuArrowLeft className="size-4 text-gray-700"/>
                </span>
                <span>Select Beneficiary</span>
              </div>
              <div className="flex-1"></div>
            </div>
            <div className="h-fit min-h-96 pb-20">
              <div className="relative mt-2 w-full max-w-xl">
                <BiSearch className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400 pointer-events-none" />
                <input
                  type="search"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full rounded-md border border-gray-300 bg-white py-2 pl-10 pr-4 text-sm transition duration-200 focus:!border-olivine-500 focus:outline-none focus:!ring-1 focus:!ring-olivine-500"
                />
              </div>
              <div className="mt-4 h-[1px] w-full bg-gray-200" />

              <div className="mt-6 w-full bg-white shadow-sm divide-y divide-gray-100 overflow-auto">
                {filteredBeneficiaries && filteredBeneficiaries.length > 0 ? (
                    filteredBeneficiaries.map((item) => (
                      <div
                        key={item.id}
                        className={`flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-gray-50 ${
                          selectedId === item.id ? "bg-green-50" : ""
                        }`}
                      >
                        <div onClick={() => setSelectedId(item.id)} className="flex items-center gap-3">
                          <img src={item.logo} alt={item.network} className="size-6" />
                          <span className="text-sm text-gray-800">{item.number}</span>
                        </div>
                        <div className="flex flex-row items-center space-x-3">
                          <div className="w-fit">
                            <Menu>
                              <div>
                                <Menu.Button className="">
                                  <BsThreeDotsVertical className="size-3.5" />
                                </Menu.Button>
                              </div>
                              <Menu.Items className="absolute px-1 py-1 bg-white border border-gray-200 rounded shadow-md">
                                <div onClick={() => handleDelete(item)} className="text-sm px-4 py-1 rounded hover:bg-gray-100 active:bg-gray-200 ">Delete</div> 
                              </Menu.Items>
                            </Menu>
                          </div>
                          <div className="w-5">
                            {selectedId === item.id && (
                              <LuCheckCircle2 className="text-green-600 w-5 h-5" />
                            )}
                          </div>
                        </div>
                        <div className="absolute right-6 bottom-3 flex items-center justify-end">
                          <button
                            onClick={() => setSearchNumber(false)}
                            className="rounded-md bg-olivine-500 px-6 py-2.5 text-sm font-semibold text-white transition duration-300 hover:bg-olivine-600 sm:px-10"
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                  <div className="h-fit min-h-full flex flex-col items-center justify-center mx-auto max-w-md">
                    <div>
                      <img src={PayBillImage} alt="" className="size-24"/>
                    </div>
                    <h2 className="mt-4 text-lg font-bold text-gray-700">No Saved Beneficiary</h2>
                    <p className="text-sm text-gray-500 text-center">You have no saved beneficiary for this category.when you save a beneficiary in this category, it will appear here.</p>
                    <div className="absolute right-6 bottom-3 flex items-center justify-end">
                      <button
                        onClick={() => setSearchNumber(!searchNumber)}
                        className="rounded-md bg-olivine-500 px-6 py-2.5 text-sm font-semibold  text-white transition duration-300 hover:bg-olivine-600 sm:px-10"
                      >
                        Back
                      </button>
                    </div>
                  </div>
                  )}
              </div>

            </div>
          </div>
        ) : (
          <div>
            <div className="mt-4 flex justify-start text-sm font-semibold text-gravel-500">
              Select Airtime Provider
            </div>
            <div className="mt-4">
              <Tab.Group
                selectedIndex={tabIndex}
                onChange={(i) => {
                  setTabIndex(i);
                  setPackageSlug(networks[i]);
                }}
              >
                <Tab.List className="flex items-center space-x-2 sm:space-x-3">
                  {networks.map((network, index) => {
                    const logos = {
                      AIRTEL_VTU: Airtel,
                      GLO_VTU: Glo,
                      MTN_VTU: MTN,
                      "9MOBILE_VTU": Nmobile,
                    };
                    const labels = {
                      AIRTEL_VTU: "Airtel Nigeria",
                      GLO_VTU: "GLO Direct",
                      MTN_VTU: "MTN",
                      "9MOBILE_VTU": "9Mobile VTU",
                    };

                    return (
                      <div key={network}>
                        <Tab as={Fragment}>
                          {({ selected }) => (
                            <button
                              className={
                                selected ? "rounded-md ring-1 ring-olivine-500" : "ring-0"
                              }
                            >
                              <div className="h-[68px] w-14 cursor-pointer space-y-1 rounded-md border border-gray-200 pt-5 xsm:h-[75px] xsm:w-[71px] sm:h-[82px] sm:w-20">
                                <div className="flex justify-center">
                                  <img
                                    src={logos[network]}
                                    className="aspect-auto h-7 w-7 object-cover xsm:h-8 xsm:w-8 sm:h-9 sm:w-9"
                                    alt=""
                                  />
                                </div>
                                <div className="flex justify-center text-[8.5px] sm:text-[11px]">
                                  {labels[network]}
                                </div>
                              </div>
                            </button>
                          )}
                        </Tab>
                      </div>
                    );
                  })}
                </Tab.List>
                <Tab.Panels>
                  {networks.map((network) => (
                    <Tab.Panel key={network}>
                      <form>
                        <div className="mt-4">
                          <label htmlFor="title" className="ml-2 text-xs font-semibold">
                            Select biller
                          </label>
                          <div className="relative mt-1 flex items-center justify-end rounded-md">
                            <div className="flex-grow">
                              <select
                                onChange={handlePackageInfo}
                                className="block h-10 w-full cursor-pointer rounded-md border-gray-300 bg-white pl-4 pr-10 text-gray-500 placeholder:text-sm optional:text-sm optional:font-semibold focus:border-olivine-500 focus:ring-olivine-500"
                              >
                                <optgroup className="rounded-lg bg-olivine-100">
                                  {packageSlug ? (
                                    <option className="text-gray-400">{packageSlug}</option>
                                  ) : (
                                    <option className="text-gray-400">Select network</option>
                                  )}

                                  <option value="AIRTEL_VTU">Airtel</option>
                                  <option value="GLO_VTU">GLO</option>
                                  <option value="MTN_VTU">MTN</option>
                                  <option value="9MOBILE_VTU">9MOBILE</option>
                                </optgroup>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="mt-[2px] flex flex-row items-center justify-end">
                          <button
                            onClick={() => setSearchNumber(!searchNumber)}
                            className="w-fit text-sm text-olivine-600 font-medium cursor-pointer hover:underline hover:underline-offset-2"
                          >
                            Select from beneficiary
                          </button>
                        </div>
                        <div className="mt-2">
                          <label
                            htmlFor="phoneNumber"
                            className="ml-2 text-xs font-semibold"
                          >
                            Mobile number
                          </label>
                          <div className="relative mt-1 flex items-center justify-end rounded-md">
                            <div className="flex-grow">
                              <input
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                type="tel"
                                placeholder="08012345678"
                                className="block h-10 w-full rounded-md border-gray-300 bg-white pl-4 pr-10 text-gravel-600 placeholder:text-sm placeholder:text-gray-400 focus:border-olivine-500 focus:ring-olivine-500"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="mt-4">
                          <label
                            htmlFor="amount"
                            className="ml-2 text-xs font-semibold"
                          >
                            Amount
                          </label>
                          <div className="relative mt-1 flex items-center justify-end rounded-md">
                            <div className="flex-grow">
                              <input
                                type="text"
                                value={amount}
                                onChange={handleChangeAmount}
                                placeholder="&#8358; 0.00"
                                className="block h-10 w-full rounded-md border-gray-300 bg-white pl-4 pr-10 text-gravel-600 placeholder:text-sm placeholder:text-gray-400 focus:border-olivine-500 focus:ring-olivine-500"
                              />
                            </div>
                          </div>
                        </div>
                      </form>
                      {phone?.length === 11 && amount ? (
                        <div>
                          <div className="text-md mt-4 text-center font-semibold text-gray-600">
                            Transaction PIN
                          </div>
                          <div className="relative mt-2 flex items-center justify-center space-x-2 rounded-md">
                            {otp.map((data, index) => (
                              <input
                                type="password"
                                maxLength={1}
                                className="block h-10 w-10 rounded-md border-gray-400 bg-white text-center text-lg font-semibold focus:border-olivine-500 focus:ring-olivine-500"
                                name="opt"
                                key={index}
                                value={data}
                                onChange={(e) => handleChange(e.target, index)}
                                onFocus={(e) => e.target.select()}
                              />
                            ))}
                          </div>
                        </div>
                      ) : null}
                      <div className="mt-2.5 flex items-center space-x-2">
                        <input
                          type="checkbox"
                          className="size-4 rounded-sm border-gray-300 checked:ring-0 focus:ring-0 text-olivine-600 cursor-pointer"
                          checked={isSavingBeneficiary}
                          onChange={handleBeneficiarySave}
                        />
                        <label className="text-sm text-gray-700 antialiased">
                          Save Information as beneficiary
                        </label>
                      </div>
                      <div className="mb-6 mt-6">
                        <div className="flex justify-between text-center tracking-wider transition-all duration-300">
                          <button
                            className="rounded-md border-[1px] border-olivine-400 px-8 py-3 text-xs text-olivine-500 transition duration-300 hover:ring-1 hover:ring-olivine-600 sm:text-sm"
                            onClick={() => onClose()}
                          >
                            CANCEL
                          </button>
                          {!isLoading ? (
                            <button
                              disabled={
                                phone?.length !== 11 ||
                                !amount ||
                                otp?.join("")?.length !== 4
                              }
                              onClick={handleSubmit}
                              className="rounded-md bg-olivine-500 px-6 py-2 text-sm font-semibold text-white transition duration-300 hover:bg-olivine-600 disabled:opacity-30 disabled:hover:bg-olivine-500 sm:px-10"
                            >
                              BUY AIRTIME
                            </button>
                          ) : (
                            <button
                              disabled
                              className="cursor-not-allowed rounded-md bg-olivine-500 px-6 py-2 text-sm font-semibold text-white transition duration-300 hover:bg-olivine-600 disabled:opacity-30 disabled:hover:bg-olivine-500 sm:px-10"
                            >
                              <IsLoadingFour />
                            </button>
                          )}
                        </div>
                      </div>
                    </Tab.Panel>
                  ))}
                </Tab.Panels>
              </Tab.Group>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default BuyAirtimePopover;